import React, { FormEvent, useCallback, useContext, useEffect, useState } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
// import TagContainer from 'src/components/counties/TagContainer';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import useFetch from 'use-http';
import DocumentTemplate from 'src/models/DocumentTemplate';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import { useForm } from 'react-hook-form';
import DocumentManagement from 'src/components/layout/DocumentManagement';
import DialogList from 'src/dialogs';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import moment from 'moment';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import * as Constants from 'src/components/common/Constants';
import Filter from 'src/components/common/Filter';
import CardContainer from 'src/components/common/CardContainer.redesign';
import { ODataOptions } from 'src/util/ODataBuilder';
import * as _ from 'lodash';
import { ITableConfig } from 'src/components/common/table';
import Card from 'src/components/common/Card.redesign';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import TemplatePreviewDialog from './TemplatePreviewDialog';

// const selectLeaseTemplates = [
//     { id: 1, name: 'Lease Template 1' },
//     { id: 2, name: 'Lease Template 2' },
//     { id: 3, name: 'Lease Template 3' },
// ];

interface IGeneratedDocsSettingStateProps {
    documentTemplates?: Array<DocumentTemplate>;
    selectedTemplateIds?: Array<number>;

    handleSuccessfulSubmit?: (reset: boolean, resetPage: boolean) => void;
}

const GeneratedDocsSetting = (props: IGeneratedDocsSettingStateProps) => {
    const docTemplateTableConfig: ITableConfig = {
        rowCount: 15,
        pageNumber: 1,
    };

    const appContext = useContext<IAppContextState>(AppContext);
    const dispatch = useDispatch();

    const { response, get, put, del } = useFetch();
    const { errors, setValue, register, reset, getValues } = useForm();

    const [selectedIds, setSelectedIds] = useState<Array<number>>([]);

    const [docTemplateList, setDocTemplateList] = useState<PagedResultSet<DocumentTemplate>>(undefined);
    const [docTemplateFilters, setDocTemplateFilters] = useState<ODataOptions>(ODataOptions.from(docTemplateTableConfig));
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [showNextPage, setShowNextPage] = useState<boolean>(false);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [previewTemplate, setPreviewTemplate] = useState<DocumentTemplate>(null);

    useEffect(() => {
        getStates();
    }, []);

    useEffect(() => {
        getDocTemplates();
    }, [docTemplateFilters]);

    useEffect(() => {
        if (docTemplateList?.items?.length > 0) {
            for (let template of docTemplateList.items) {
                template.modifiedDate = moment(template.modifiedDate).format('YYYY-MM-DD') as unknown as Date;
            }

            setShowNextPage(docTemplateList.pageNumber * docTemplateList.pageSize < docTemplateList.totalRecords);
            reset({ documentTemplates: docTemplateList.items });
        }
    }, [docTemplateList]);

    useEffect(() => {
        if (props?.documentTemplates?.length > 0 && props?.selectedTemplateIds?.length > 0) {
            for (let temp of props?.documentTemplates) {
                setValue(
                    `docTemplates-${temp.id}`, 
                    props.selectedTemplateIds.includes(temp.id)
                );
            }
            setSelectedIds(props.selectedTemplateIds);
        }
    }, [props]);

    // const resetPage = () => {
    //     setDocTemplateList(undefined);
    //     setPageNumber(1);
    //     setShowNextPage(false);
    //     setDocTemplateFilters(ODataOptions.from(docTemplateTableConfig));
    // };

    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to get the States Data!!!');
        }
    };

    const getDocTemplates = async () => {
        let filterString = '';
        let increment = false;
        if (!!docTemplateFilters) {
            filterString = docTemplateFilters.toString();
            increment = docTemplateFilters.getPageNumber() > 1;
        }

        const result = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate/paged${filterString}`);

        if (response.ok) {
            if (increment) {
                let tempResult = _.cloneDeep(docTemplateList);
                tempResult.pageNumber += 1;
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setDocTemplateList(tempResult);
            } else {
                setDocTemplateList(result);
            }
        }
    };

    const parseBool = (value: string) => {
        if (value === 'true') {
            return true;
        }

        return false;
    };

    const handleSubmit = (index: number = null) => {
        let submitValues = getValues();
        let currentDocTempList = new PagedResultSet<DocumentTemplate>();
        currentDocTempList.totalRecords = docTemplateList.totalRecords;
        currentDocTempList.pageNumber = docTemplateList.pageNumber;
        currentDocTempList.pageSize = docTemplateList.pageSize;
        currentDocTempList.items = [];

        if (index !== null) {
            let row = finalizeDocTemplate(submitValues.documentTemplates[index], index);
            currentDocTempList.items[index] = row;

            updateTemplate(row).then((result: boolean) => {
                if (result === true) {
                    props.handleSuccessfulSubmit(false, false);
                }
            });
        } else {
            let isSuccess: boolean = true;
            const saves: Array<Promise<void>> = [];

            for (let i = 0; i < docTemplateList.items.length; i++) {
                let formValue = finalizeDocTemplate(submitValues.documentTemplates[i], i);
                if (!_.isEqual(formValue, docTemplateList.items[i])) {
                    saves.push(
                        updateTemplate(formValue).then((result: boolean) => {
                            isSuccess = isSuccess && result;
                        })
                    );
                }
                currentDocTempList.items[i] = formValue;
            }

            if (isSuccess) {
                props.handleSuccessfulSubmit(false, false);
                setDocTemplateList(currentDocTempList);
            }

            Promise.all(saves).then(reloadFromFirstPage);
        }
    };

    const handleAction = async (index: number, action: 'DELETE' | 'DOWNLOAD') => {
        let template = docTemplateList.items[index];

        if (template.id > 0) {
            switch (action) {
                case 'DELETE':
                    await del(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate/${template.id}`).then(() => {
                        // resetPage();
                        let newList = { ...docTemplateList };
                        if (showNextPage) {
                            newList.items.splice(newList.items.length - newList.pageSize);
                            newList.totalRecords -= 1;
                            setDocTemplateList(newList);
                            getDocTemplates();
                        } else {
                            newList.items.splice(index, 1);
                            newList.totalRecords -= 1;
                            setDocTemplateList(newList);
                        }
                        props.handleSuccessfulSubmit(false, showNextPage);
                    }).catch((error) => {
                        window.alert('Error Deleting Document Template');
                        console.log('Doc Template Delete Failure:', error);
                    });
                    break;
                case 'DOWNLOAD':
                    let filename = template.originalFileName;
                    await get(`/v1.0/s3bucket/Templates/${filename}`);
                    if (response.ok) {
                        await response.blob().then((blob) => {
                            const blobUrl = window.URL.createObjectURL(blob);
                            const a = document.getElementById(`a_templateDoc`) as HTMLAnchorElement;
                            a.href = blobUrl;
                            a.download = filename;
                            a.click();
                            window.URL.revokeObjectURL(blobUrl);
                        });
                    }            
                    break;
                default:
                    break;
            }

        } else {
            window.alert(`Invalid Document Template Id: ${template.id}`);
        }
    };

    // const handleReplace = (index: number) => {
    //     // To Be Implemented...
    //     window.alert('Not Yet Implemented');
    // };

    const updateFilter = (options: ODataOptions) => {
        let initOptions = ODataOptions.from(docTemplateTableConfig);
        initOptions.merge(options);

        searchUpdate(initOptions);
    };

    const searchUpdate = useCallback(
        _.debounce((filter: ODataOptions) => {
            setPageNumber(1);
            setDocTemplateFilters(filter);
        }, 800),
        []
    );

    // The server lists included templates first, so after anything that changes which templates are included,
    // reload from page 1 (keeping the search/sort): they move into place, and "load more" offsets match the new order.
    const reloadFromFirstPage = () => {
        setPageNumber(1);
        setDocTemplateFilters((current) => ODataOptions.from(docTemplateTableConfig).merge(current));
    };

    const handleTemplateSelection = (e: FormEvent<HTMLInputElement>, templateId: number) => {
        let templates = [...selectedIds];

        if (e.currentTarget.checked === true) {
            templates.push(templateId);
        } else {
            templates.splice(templates.indexOf(templateId), 1);
        }

        setSelectedIds(templates);
    };

    const uploadNewTemplate = () => {
        dispatch(actions.layout.showDialog(DialogList.DOCUMENT_MANAGEMENT));
    };

    const filesUploaded = () => {
        dispatch(actions.layout.hideDialog());
        props.handleSuccessfulSubmit(true, showNextPage);
        // The server includes an uploaded template in the project, so it belongs with the included ones at the top.
        reloadFromFirstPage();
    };

    const updateTemplate = async (docTemplate: DocumentTemplate) => {
        await put(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate`, docTemplate);

        if (response.ok) {
            return true;
        } else {
            return false;
        }
    };

    const uploadNewDocTemplate = () => {
        uploadNewTemplate();
    };

    const onIncrementPage = () => {
        if (pageNumber * docTemplateList.pageSize < docTemplateList.totalRecords) {
            let newConfig = docTemplateTableConfig;
            newConfig.pageNumber = pageNumber + 1;

            const options = ODataOptions.from(newConfig);
            options.merge(docTemplateFilters);

            setDocTemplateFilters(options);
            setPageNumber(pageNumber + 1);
        }
    };

    const finalizeDocTemplate = (template: DocumentTemplate, index: number) => {
        let currTemplate = docTemplateList.items[index];

        template.id = currTemplate.id;
        template.contractTypeId = currTemplate.contractTypeId;
        template.contractType = currTemplate.contractType;
        template.contractTypeReferenceNumber = currTemplate.contractTypeReferenceNumber;
        template.referenceNumber = currTemplate.referenceNumber;
        template.originalFileName = currTemplate.originalFileName;
        template.fileSize = currTemplate.fileSize;
        template.modifiedDate = (moment(new Date()).format('YYYY-MM-DD') as unknown as Date);

        template.acknowledgmentRequired = template.acknowledgmentRequired ? template.acknowledgmentRequired : false;

        template.name = template.name ? template.name : '';
        template.docType = template.docType ? template.docType : '';
        template.templateNumber = template.templateNumber ? template.templateNumber : '';
        template.documentDescription = template.documentDescription ? template.documentDescription : '';

        template.referenceNumber = template.referenceNumber ? parseInt(template.referenceNumber + '', 10) : null;
        template.stateId = template.stateId ? parseInt(template.stateId + '', 10) : null;
        template.leaseDescriptionWindow = template.leaseDescriptionWindow ? parseInt(template.leaseDescriptionWindow + '', 10) : null;
        template.leaseClientNumber = template.leaseClientNumber ? parseInt(template.leaseClientNumber + '', 10) : null;

        template.isSelected = template.isSelected ? parseBool(template.isSelected + '') : false;

        return template;
    };

    const displayTemplate = (index: number) => {
        const cardActions: ContextMenuAction[] = [
            { text: 'Preview Template', action: () => setPreviewTemplate(docTemplateList.items[index]) },
            // { text: 'Replace Template', action: () => handleReplace(index) },
            { text: 'Delete Template', action: () => handleAction(index, 'DELETE') },
            { text: 'Download Template', action: () => handleAction(index, 'DOWNLOAD') },
        ];

        return (
            <Card
                contextActions={cardActions}
                newContext={true}
                showMenu={true}
            >
                <div hidden={true}>
                    <RHFInputBox label="" name={`documentTemplates[${index}].id`} register={register} errors={errors} disabled={true} />
                    <a id="a_templateDoc" />
                </div>
                <div className="flex ml-2" style={{ justifyContent: 'center', borderBottom: '1px solid darkgrey', paddingBottom: '1rem' }}>
                        <RHFCheckbox
                            bodyStyle={{ width: '5%' }}
                            style={{ width: '100%' }}
                            // bodyStyle={{ width: '15%' }}
                            name={`documentTemplates[${index}].isSelected`}
                            // label="Include"
                            onClick={(e) => handleTemplateSelection(e, docTemplateList.items[index].id)}
                            register={register}
                        />

                        <RHFInputBox
                            bodyStyle={{ width: '7%' }}
                            style={{ width: '100%' }}
                            // label="Template Number"
                            name={`documentTemplates[${index}].templateNumber`}
                            register={register}
                            type="text"
                            errors={errors}
                            disabled={true}
                        />

                        <RHFInputBox
                            bodyStyle={{ width: '20%' }}
                            style={{ width: '100%' }}
                            // label="Document Name"
                            name={`documentTemplates[${index}].name`}
                            register={register}
                            type="text"
                            errors={errors}
                        />
                        <RHFSelect
                            bodyStyle={{ width: '17%' }}
                            style={{ width: '100%' }}
                            // label="Template Type"
                            name={`documentTemplates[${index}].docType`}
                            options={Object.values(Constants.documentTemplateTypes).map(lt => { return { value: lt, label: lt }; })}
                            register={register}
                            errors={errors}
                        />

                        <RHFSelect
                            bodyStyle={{ width: '17%' }}
                            style={{ width: '100%' }}
                            // label="Lease Type"
                            name={`documentTemplates[${index}].contractType`}
                            options={Object.values(Constants.contractTypeRef).map(lt => { return { value: lt.label, label: lt.label as string }; })}
                            register={register}
                            errors={errors}
                        />

                        <RHFInputBox
                            bodyStyle={{ width: '17%' }}
                            style={{ width: '100%' }}
                            // label="Document Description"
                            name={`documentTemplates[${index}].documentDescription`}
                            register={register}
                            type="text"
                            errors={errors}
                        />

                        <RHFInputBox
                            bodyStyle={{ width: '17%' }}
                            style={{ width: '100%' }}
                            // label="Modified Date"
                            name={`documentTemplates[${index}].modifiedDate`}
                            register={register}
                            type="date"
                            errors={errors}
                            disabled={true}
                        />
                        {/* <div className="flex" key={`template-${index}`}> */}
                        {/* <RHFInputBox
                            bodyStyle={{ width: '20%' }}
                            // style={{ width: '100%' }}
                            label="Original Filename"
                            name={`documentTemplates[${index}].originalFileName`}
                            register={register}
                            type="text"
                            errors={errors}
                            disabled={true}
                        /> */}

                        {/* <RHFInputBox
                            bodyStyle={{ width: '20%' }}
                            // style={{ width: '100%' }}
                            label="File Size (kB)"
                            name={`documentTemplates[${index}].fileSize`}
                            register={register}
                            type="text"
                            errors={errors}
                            disabled={true}
                        /> */}

                        {/* <RHFInputBox
                            bodyStyle={{ width: '20%' }}
                            // style={{ width: '100%' }}
                            label="Lease Dsc Window"
                            name={`documentTemplates[${index}].leaseDescriptionWindow`}
                            register={register}
                            type="text"
                            errors={errors}
                        /> */}

                        {/* <RHFCheckbox 
                            bodyStyle={{ width: '20%' }}
                            // style={{ width: '100%' }}
                            name={`documentTemplates[${index}].acknowledgmentRequired`}
                            label="Ack Required?" 
                            register={register}
                            errors={errors}
                        /> */}
                        {/* </div> */}
                    {/* <div className="flex-column">
                        {/* <Button
                        className="blue-hover-button"
                        text="Update"
                        onClick={() => handleSubmit(index)}
                        disabled={!formState.isDirty}
                        style={{ marginTop: '1rem' }}
                    /> 
                        <Button
                            className="blue-hover-button"
                            text="Replace"
                            onClick={() => handleReplace(index)}
                            style={{ marginTop: '1rem' }}
                        />
                        <Button
                            className="blue-hover-button"
                            text="Delete"
                            onClick={() => handleDelete(index)}
                            style={{ marginTop: '1rem' }}
                        />
                    </div> */}
                </div>
            </Card>
        );
    };

    return (
        <div>
            <div>
                <form onSubmit={() => handleSubmit()} id="docTemplateForm">
                    <Filter
                        sortItems={[
                            { group: 1, text: 'Name', icon: 'alpha-down', orderName: 'name', orderDirection: 'descending' },
                            { group: 1, text: 'Number', icon: 'numeric-up', orderName: 'templateNumber', orderDirection: 'ascending' },
                        ]}
                        filterItems={[
                            { group: 1, text: 'Template Name', orderName: 'name', orderDirection: 'descending' },
                            { group: 1, text: 'Document Type', orderName: 'docType', orderDirection: 'descending' },
                            { group: 1, text: 'Contract Type', orderName: 'contractType', orderDirection: 'descending' },
                            { group: 1, text: 'Original Filename', orderName: 'originalFilename', orderDirection: 'descending' },
                            { group: 1, text: 'IsSelected', orderName: 'isSelected', orderDirection: 'descending' },
                        ]}
                        onFilterChanged={updateFilter}
                    />
                    {!!docTemplateList && !!states && (
                        <>
                            <div className="flex" style={{ justifyContent: 'center', borderBottom: '1px solid darkgrey', width: '97%' }}>
                                <div className="form-field" style={{ width: '5%' }}>
                                    Include
                                </div>
                                <div className="form-field" style={{ width: '7%' }}>
                                    Number
                                </div>
                                <div className="form-field" style={{ width: '20%' }}>
                                    Document Name
                                </div>
                                <div className="form-field" style={{ width: '17%' }} >
                                    Document Type
                                </div>
                                <div className="form-field" style={{ width: '17%' }} >
                                    Contract Type
                                </div>
                                <div className="form-field" style={{ width: '17%' }} >
                                    Description
                                </div>
                                <div className="form-field" style={{ width: '17%' }} >
                                    Modified Date
                                </div>
                            </div> 

                            <CardContainer
                                style={{ overflow: 'auto', maxHeight: '65vh' }}
                                nextPageAction={onIncrementPage}
                                showNextPagePanel={showNextPage}
                                buttonPaging={true}
                            >
                                {docTemplateList?.items.map((dt: DocumentTemplate, index: number) => {
                                    return displayTemplate(index);
                                })}
                            </CardContainer>
                            <div>
                                <Button text="Save All" type="submit" className="mr-2" intent="primary" />
                                <Button
                                    className="blue-hover-button"
                                    text="Upload new Template"
                                    onClick={() => uploadNewDocTemplate()}
                                    style={{ marginTop: '1rem' }}
                                />
                            </div>
                        </>
                    )}
                    {/* <div style={{ padding: '2rem' }}>
                        <Button text="Save" type="submit" className="mr-2" intent="primary" />
                    </div> */}
                </form>
                {/* <div>{JSON.stringify(values, null, 2)}</div> */}
            </div>

            <DocumentManagement filesUploaded={filesUploaded} context="document template" clientNumber={appContext.clientNumber} projectNumber={appContext.projectNumber} />
            <TemplatePreviewDialog
                template={previewTemplate}
                clientNumber={appContext.clientNumber}
                projectNumber={appContext.projectNumber}
                onClose={() => setPreviewTemplate(null)}
            />
        </div>
    );
};

export default GeneratedDocsSetting;



// WEBPACK FOOTER //
// ./src/components/project/sections/GeneratedDocsSetting.tsx